import { z } from 'zod';
export const ContactTriggerNameSchema = z.enum([
    'claimCreated',
    'claimContactReceived',
    'contactMerged',
    'contactAssignedToClaim',
    'contactAssignedToJob',
    'globalContactReceived',
    'jobAssignedToClaim',
    'userCreated',
    'userUpdated',
]);
export const ContactTriggerNameEnum = ContactTriggerNameSchema.enum;
